import { connect } from 'react-redux';

import KnowledgeForm from './KnowledgeForm.js';
// import { redux as apiRedux } from '../api';

const mapStateToProps = state => {
  return {
    user: state.api.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

const ConnectedKnowledge = connect(
  mapStateToProps,
  mapDispatchToProps
)(KnowledgeForm);

export default ConnectedKnowledge;
